/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-17 10:40 VN — WEB-20261017-suzitee-header-pro
   Đã làm: JS nhỏ cho header desktop (chỉ chạy khi >=1024px):
   (1) gắn html.sz-hdr-compact khi cuộn >200px (scroll passive + rAF, chỉ đổi class khi trạng thái đổi) -> CSS hiện header gọn 1 hàng.
   (2) gắn a.mini_cart.sz-cart-empty khi số giỏ = 0 -> CSS ẩn badge "0". Observer HẸP chỉ trên từng nút giỏ (không observe body).
   Không đổi DOM, link, logic search/giỏ. Gỡ: bỏ dòng include trong snippets/sz-head-assets.liquid. */
(function () {
  try {
    var mq = window.matchMedia('(min-width: 1024px)');
    var root = document.documentElement;
    var ticking = false, scrolled = null, observers = [];

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var s = (window.pageYOffset || 0) > 200;
        if (s !== scrolled) { scrolled = s; root.classList.toggle('sz-hdr-compact', s); }
      });
    }

    function syncCart(a) {
      var c = a.querySelector('.cart_count');
      var empty = !c || (c.textContent || '').trim() === '' || (c.textContent || '').trim() === '0';
      if (a.classList.contains('sz-cart-empty') !== empty) a.classList.toggle('sz-cart-empty', empty);
    }

    function enable() {
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      var links = document.querySelectorAll('#shopify-section-header .not-sticky-main-nav .cart-container > a.mini_cart');
      for (var i = 0; i < links.length; i++) {
        (function (a) {
          syncCart(a);
          var mo = new MutationObserver(function () { syncCart(a); });
          mo.observe(a, { childList: true, characterData: true, subtree: true });
          observers.push(mo);
        })(links[i]);
      }
    }

    function disable() {
      window.removeEventListener('scroll', onScroll);
      observers.forEach(function (mo) { mo.disconnect(); });
      observers = [];
      scrolled = null;
      root.classList.remove('sz-hdr-compact');
    }

    function init() { if (mq.matches) enable(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    var onChange = function (e) { if (e.matches) enable(); else disable(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange); else if (mq.addListener) mq.addListener(onChange);
  } catch (e) { /* không làm vỡ trang nếu lỗi */ }
})();
